<template>
    <div class="proposal-confirmation-container">
        <title-bar class="margin-bottom-huge brand-name" :title="brandName" />
        <div class="proposal-confirmation-block">
            <div class="margin-bottom-large">
                <g-typography tag="h1" font-weight="semibold" :value="pageTitle" />
            </div>
            <div class="margin-bottom-large">
                <g-typography tag="p" :value="pageDescription" />
            </div>
            <div class="dashboard-button-wrapper">
                <g-button
                    class="dashboard-button"
                    type="primary"
                    shape="round"
                    theme="live"
                    size="large"
                    @click="handleContinue"
                >
                    Continue
                </g-button>
            </div>
        </div>
        <div class="footer-block">
            <powered-by-grin :clickable="true" />
        </div>
    </div>
</template>

<script>
    import PageLayout from '../../../layouts/PageLayout.vue';
    import TitleBar from '../../../library/TitleBar.vue';
    import get from 'lodash/get';
    import { getCustomizableTitle, getProposalStepOverview } from '../../../../helpers/default-texts';
    import { useAuthStore } from '../../../../../stores';

    export default {
        name: 'ProposalConfirmation',
        components: {
            TitleBar,
            PageLayout
        },
        props: {
            campaign: {
                type: Object
            },
            contact: {
                type: Object
            }
        },
        computed: {
            brandName() {
                return get(this, 'campaign.brand.name', '');
            },
            pageTitle() {
                return getCustomizableTitle(this.campaign, 'proposal_submitted_header');
            },
            pageDescription() {
                return getProposalStepOverview(
                    this.campaign,
                    'proposal_submitted_text',
                    'Thanks for your interest in this campaign! You should hear back from us soon.'
                );
            }
        },
        methods: {
            handleContinue() {
                if (this.$root.account_makes_payments && this.$root.needsLogin && !useAuthStore().isLoggedIn) {
                    this.$router.push({ name: 'v2.account.verify' });
                    return;
                }
                window.location.href = `/${this.contact.live_url}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-large {
        margin-bottom: $g-spacing-6;
    }

    .margin-bottom-huge {
        margin-bottom: $g-spacing-9;
    }

    .dashboard-button-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .proposal-confirmation-block {
        text-align: center;
        margin-top: 8em;
        margin-bottom: $g-spacing-8;
    }

    .proposal-confirmation-container {
        & .footer-block {
            padding: $g-spacing-6;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
        }
    }
</style>
